import { CONFIG } from '@/constants';

const config = {
  [CONFIG.PAYMENT.METHOD_KEY.BANK_TRANSFER]: 'Bank transfer',
  [CONFIG.PAYMENT.METHOD_KEY.CREDIT_CARD]: 'Credit card',
};

export default config;
